/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    cancel: ghb({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "Cancel "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"fileToCancel") || (depth0 != null ? lookupProperty(depth0,"fileToCancel") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"fileToCancel","hash":{},"data":data,"loc":{"start":{"line":1,"column":7},"end":{"line":1,"column":23}}}) : helper)));
},"useData":true})
};